export enum HomeScreenSectionTypeEnum {
  PromotedStore = 1,
  PromotedStores = 2,
  NearbyList = 3,
  PromotedProducts = 4,
  Slider = 5,
  OneImage = 6,
  TwoImages = 7,
  ThreeImages = 8,
  FourImages = 9,
  RecommendedStores = 10,
  TrendingStores = -1,
  TrendingProducts = -2,
  TimeBasedStores = 12,
  DigitalCards = -3,
}
